export class WebpayController {

  constructor($scope, $rootScope, $location, $timeout, PaymentService, $modal, $sce) {
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.location = $location;
    this.timeout = $timeout;
    this.PaymentService = PaymentService;
    this.sce = $sce;

    this.init();
  }

  init() {
    if(!this.rootScope.payment_price || !this.rootScope.payment_days) {
      this.location.path('/homerd/centrodepago');
    }

    this.PaymentService.webpayInit(this.rootScope.currentUserProfile._id, this.rootScope.payment_price, this.rootScope.payment_days)
      .then((response) => { let data = response.data;
        this.scope.uri = this.sce.trustAsResourceUrl(data.data.url);
        this.scope.token = data.data.token;

        this.timeout(function() {
          angular.element("#webpayform").submit();
        });
      })
      .catch((response) => { let err = response.data;
        console.error(err);
        this.location.path('/homerd/centrodepago/fail')
      });
  }
}
